import React, { useState } from 'react';
import { Container, Area, StickyArea } from './index.style';
import { Tabs } from '../../Generic';
import RisksSaving from './RisksSaving';
import Cars from './Cars';

const tabs = ['risks', 'longTimeSavings', 'cars'];

const renderTab = (setFormActive, tab, { risks, longTimeSavings, cars }) => {
    switch (tab) {
        case 'risks':
        default:
            return <RisksSaving
                setFormActive={setFormActive}
                content={risks}
            />;
        case 'longTimeSavings':
            return <RisksSaving
                setFormActive={setFormActive}
                content={longTimeSavings}
            />;
        case 'cars':
            return <Cars
                setFormActive={setFormActive}
                content={cars}
            />;
    }
};

const Information = ({ setFormActive, top, risks, longTimeSavings, cars }) => {
    const [tab, setTab] = useState(tabs[0]);
    const { longTimeSavingsTabTitle, risksTabTitle, carsTabTitle } = top;

    const tabNames = {
        risks: risksTabTitle.text,
        longTimeSavings: longTimeSavingsTabTitle.text,
        cars: carsTabTitle.text,
    };
    return <StickyArea>
        <Tabs
            tabs={tabs}
            tab={tab}
            setTab={setTab}
            tabNames={tabNames}
        />
        <Container>
            <Area>
                {renderTab(setFormActive, tab, { risks, longTimeSavings, cars })}
            </Area>
        </Container>
    </StickyArea>;
};

export default Information;